import { FC, ReactNode } from 'react'
import papers from '../assets/papers.svg'

type EmptyScreenProps = {
  children: ReactNode
}

const EmptyScreen: FC<EmptyScreenProps> = ({ children }) => {
  return (
    <div className="flex flex-col h-full px-16">
      <div className="mx-auto mt-32 pb-7">
        <img alt="papers" src={papers} />
      </div>
      <div className="text-grey text-center">{children}</div>
    </div>
  )
}

export default EmptyScreen
